import type { MatchTab } from "./types";

export const matchTabs: MatchTab[] = [
  "total",
  "live",
  "finished",
  "hot",
  "follow",
  "odds",
];

export const apiMatchTabs: MatchTab[] = [
  "total",
  "live",
  "finished",
  "hot",
  "odds",
];

export const SETTINGS_STORAGE_KEY = "gwd_livescore_settings";
export const FAVORITES_STORAGE_KEY = "gwd_livescore_favorites";
export const GROUP_MODE_STORAGE_KEY = "gwd_livescore_group_mode";

export const ACTIVE_TAB_POLL_INTERVAL_MS = 5000;
export const MATCH_CLOCK_INTERVAL_MS = 60000;
export const WAKE_SYNC_STALE_MS = 15000;
export const COUNTS_SYNC_STALE_MS = 30000;
export const ODD_CHANGE_HOLD_MS = 10000;
export const MATCH_INSIGHT_CACHE_MS = 30000;
export const MATCH_INSIGHT_CLOSE_DELAY_MS = 180;
export const MATCH_INSIGHT_RETURN_LIST = ["info", "incidents", "stats"];

export const LIVESTREAM_ROUTE_PATH = "/truc-tiep/";
export const LIVESTREAM_FALLBACK_DOMAINS: string[] = [];
export const MOBILE_VIEW_QUERY = "(max-width: 768px)";
